import { DocumentStore } from './DocumentStore'
import { FileDocument } from './FileDocument'

export class MarkdownDocument extends FileDocument {
  constructor(store: DocumentStore, path: string, fileHandle: FileSystemFileHandle) {
    super(store, path, fileHandle)
  }
}
